import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioPointModel } from 'src/app/core/models/radio-point.model';

@Component({
  selector: 'app-radio-point',
  templateUrl: './radio-point.component.html',
  styleUrls: ['./radio-point.component.scss']
})
export class RadioPointComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: RadioPointModel;

  @HostBinding('class.block-radio-text') apply = true;
  @HostBinding('class.my-4') apply1 = true;

  isUpdateClick = false;
  /**
   * @description constructor
   */
  constructor() { }
  /**
   * @description metodo inicio
   */
  ngOnInit(): void {
    this.setValueInForm();
  }
  /**
   * @description colocar valor en formulario
   */
  setValueInForm(): void {
    if (!this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value === false) {
    }
  }
  // /**
  //  * @description recuprar valor en formulario
  //  */
  // getValueInForm(): any {
  //   return this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
  // }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }
  /**
   * @description actualizar datos
   * @params checkOption
   */
  public updateData(checkOption: boolean): void {
    if (!this.checkDataCompOk()) { return; }
    // Si el checkoption es true será '1' sino sera '0'
    let toBit = '0';
    if (checkOption) { toBit = '1'; }
    const ID: string = this.DATA_CONFIG.id;
    // conseguimos el array de terminos
    const ARR_TERMS: any[] = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    const IDX_IN_ARR: number = ARR_TERMS.findIndex(e => ID === e.Id_Tipo_Consentimiento);
    ARR_TERMS[IDX_IN_ARR].Aceptacion = toBit;
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath)
      .setValue(ARR_TERMS);
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).markAsTouched();
    this.isUpdateClick = true;
  }
  /**
   * @description buscar en array
   * @params id
   */
  findMeInArr(id: string): boolean {
    let toBool = false;
    if (id) {
      //  Conseguimos el array de terminos
      const ARR_TERMS: any[] = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
      // Buscamos el idx en el array
      const idxInArrTerms: number = ARR_TERMS.findIndex(e => id === e.Id_Tipo_Consentimiento);
      const EL: any = ARR_TERMS[idxInArrTerms].Aceptacion;
      toBool = true;
      if (EL === '0') { toBool = false; }
    }
    return toBool;
  }
}
